$(function () {
    if ($('form#StatementSummaryForm').length > 0) {
        $('.datepicker').datetimepicker('options', {
            viewMode: 'months',
            format: "YYYY-MM",
            locale: jsLangCode,
            keepOpen: false,
            maxDate: new Date()
        });

        $(".btn-detail").click(function(){
            var id = $(this).attr("data-id");

            // We need to hide any rows on the modal for other months
            // and only show the rows for the selected month
            $(".detail-row").each(function (){
                if($(this).attr("data-id") == id) {
                    $(this).removeClass("d-none");
                } else {
                    $(this).addClass("d-none");
                }
            });

            $("#detailModal").modal({
                'backdrop': 'static'
            });
        });

        function UpdateChartSize() {
            
            var ratio = screen.width > screen.height ? 2 : 1;

            var chartCanvases = $("canvas");

            chartCanvases.each(function() {
                var id = $(this).attr("id")

                var chart = Chart.getChart(id);

                if(chart) {
                    var parent = $(this).parent();

                    if (parent.width() > 0) {
                        parent.height(parent.width() / ratio);
                    }
                }
            });
        }

        $(window).resize(function() {
            UpdateChartSize();
        }).resize();

        $(window).on("orientationchange", function () {
            UpdateChartSize();
        });

        var chartColours = ['#0069aa', '#c8102e', '#006055', '#9500FF', '#d6a329', '#000000', '#772432' ]

        const totalAmountsFooter = (tooltipItems) => {
            var formatter = new Intl.NumberFormat(jsLangCode,{ minimumFractionDigits: 2, maximumFractionDigits: 2 });

            var data = tooltipItems[0].dataset.data[tooltipItems[0].dataIndex];

            return jsWspLabel + ': ' + formatter.format(data.wspAmount) + '\r\n' +
                jsFsLabel + ': ' + formatter.format(data.fsAmount) + '\r\n' +
                jsOgLabel + ': ' + formatter.format(data.ogAmount) + '\r\n' +
                jsPsLabel + ': ' + formatter.format(data.psAmount) + '\r\n' +
                jsIsLabel + ': ' + formatter.format(data.isAmount) + '\r\n' +
                jsMpLabel + ': ' + formatter.format(data.mpAmount) + '\r\n' +
                jsTotalLabel + ': ' + formatter.format(data.totalAmount);
        };

        const totalAmountsCanvas = document.getElementById('totalAmountsChart');

        // Need to use a custom plugin to givethe charts a background color for export,
        // otherwise they're transparent'
        const bgPlugin = {
          id: 'customCanvasBackgroundColor',
          beforeDraw: (chart, args, options) => {
            const {ctx} = chart;
            ctx.save();
            ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = options.color || '#99ffff';
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
          }
        };

        // Note: The 'totals' object comes from the C# page
        new Chart(totalAmountsCanvas, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        data: totals,
                        backgroundColor: chartColours[0],
                        parsing: {
                            xAxisKey: 'date',
                            yAxisKey: 'totalAmount'
                        }
                    }
                ]
            },
            options: {
                onresize: function (a, b) { console.log(a); console.log(b); },
                maintainAspectRatio: false,
                animation: false,
                locale: jsLangCode,
                plugins: {
                    legend: { display: false },
                    title: {
                        display: true,
                        text: jsTotalAmountsLabel,
                        color: "#000000",
                        font: {
                            size: 14
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: () => null,
                            footer: totalAmountsFooter
                        },
                        footerFont: {
                            weight: "normal"
                        }
                    },
                    customCanvasBackgroundColor: {
                        color: 'white'
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
            plugins: [bgPlugin]
        });

        const trendsLabel = (context) => {
            var formatter = new Intl.NumberFormat(jsLangCode, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            return context.dataset.label + ': ' + formatter.format(context.parsed.y)
        };

        const trendsCanvas = document.getElementById('trendsChart');

        new Chart(trendsCanvas, {
            type: 'line',
            data: {
                datasets: [
                    {
                        label: jsWspLabel,
                        data: totals,
                        backgroundColor: chartColours[0],
                        borderColor: chartColours[0],
                        parsing: {
                            xAxisKey: 'date',
                            yAxisKey: 'wspAmount'
                        }
                    },
                    {
                        label: jsFsLabel,
                        data: totals,
                        backgroundColor: chartColours[1],
                        borderColor: chartColours[1],
                        parsing: {
                            xAxisKey: 'date',
                            yAxisKey: 'fsAmount'
                        }
                    },
                    {
                        label: jsOgLabel,
                        data: totals,
                        backgroundColor: chartColours[2],
                        borderColor: chartColours[2],
                        parsing: {
                            xAxisKey: 'date',
                            yAxisKey: 'ogAmount'
                        }
                    },
                    {
                        label: jsPsLabel,
                        data: totals,
                        backgroundColor: chartColours[3],
                        borderColor: chartColours[3],
                        parsing: {
                            xAxisKey: 'date',
                            yAxisKey: 'psAmount'
                        }
                    },
                    {
                        label: jsIsLabel,
                        data: totals,
                        backgroundColor: chartColours[4],
                        borderColor: chartColours[4],
                        parsing: {
                            xAxisKey: 'date',
                            yAxisKey: 'isAmount'
                        }
                    }
                ]
            },
            options: {
                maintainAspectRatio: false,
                animation: false,
                locale: jsLangCode,
                elements: {
                    point: {
                        pointRadius: 5,
                        pointHoverRadius: 6
                    }
                },
                plugins: {
                    title: {
                        display: true,
                        color: "#000000",
                        text: jsTrendsLabel,
                        font: {
                            size: 14
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: trendsLabel
                        }
                    },
                    legend: {
                        position: 'bottom'
                    },
                    customCanvasBackgroundColor: {
                        color: 'white'
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
            plugins: [bgPlugin]
        });

        var wspTotal = 0;
        var fsTotal = 0;
        var ogTotal = 0;
        var psTotal = 0;
        var isTotal = 0;
        var mpTotal = 0;

        for(var i = 0; i < totals.length; i++){
            wspTotal += totals[i].wspAmount;
            fsTotal += totals[i].fsAmount;
            ogTotal += totals[i].ogAmount;
            psTotal += totals[i].psAmount;
            isTotal += totals[i].isAmount;
            mpTotal += totals[i].mpAmount;
        }

        var total = wspTotal + fsTotal + ogTotal + psTotal + isTotal + mpTotal;

        wspPercent = 0;
        fsPercent = 0;
        ogPercent = 0;
        psPercent = 0;
        isPercent = 0;
        mpPercent = 0;

        if (total > 0) {
            wspPercent = (wspTotal / (total)) * 100;
            fsPercent = (fsTotal / (total)) * 100;
            ogPercent = (ogTotal / (total)) * 100;
            psPercent = (psTotal / (total)) * 100;
            isPercent = (isTotal / (total)) * 100;
            mpPercent = (mpTotal / (total)) * 100;
        }

        const programPercentagesLabel = (context) => {
            var formatter = new Intl.NumberFormat(jsLangCode, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            return context.label + ': ' + formatter.format(context.raw) + "%"
        };

        const programPercentagesCanvas = document.getElementById('programPercentagesChart');

        new Chart(programPercentagesCanvas, {
            type: 'pie',
            data: {
                labels: [jsWspLabel,jsFsLabel, jsOgLabel, jsPsLabel,jsIsLabel, jsMpLabel],
                datasets: [
                    {
                        label: jsTotalLabel,
                        data: [wspPercent, fsPercent, ogPercent, psPercent, isPercent, mpPercent],
                        backgroundColor: chartColours,
                        rotation: 180,
                        borderColor: chartColours
                    }
                ]
            },
            options: {
                //elements: {
                //    arc: {
                //        borderWidth: 0,
                //    }
                //},
                maintainAspectRatio: false,
                animation: false,
                locale: jsLangCode,
                plugins: {
                    title: {
                        display: true,
                        color: "#000000",
                        text: jsProgramPercentagesLabel,
                        font: {
                            size: 14
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title: () => null,
                            label: programPercentagesLabel
                        }
                    },
                    legend: {
                        position: 'bottom'
                    },
                    customCanvasBackgroundColor: {
                        color: 'white'
                    }
                }
            },
            plugins: [bgPlugin]
        });

        $("a.nav-link").click(function () {
            var href = $(this).attr("href");

            if($(href).find("canvas").length > 0){
                $("#ExportTable").addClass("d-none");
                $("#ExportChart").removeClass("d-none");
            } else {
                $("#ExportTable").removeClass("d-none");
                $("#ExportChart").addClass("d-none");
            }
        });

        $(".nav-link").on("shown.bs.tab", function () { UpdateChartSize(); })

        $("#ExportChart").click(function(e) {
            e.preventDefault();
            e.stopPropagation();

            // find the canvas element currently shown
            var chartElement = $(".tab-pane.show").find("canvas").first();

            if(chartElement) {
                // if we find the element, we can use chart.js to get the chart object...
                var id = chartElement.attr("id")

                var chart = Chart.getChart(id);

                var title = chart.options.plugins.title.text;
                var date = new Date().toISOString().substring(0, 10);

                // .. and export it to an image file.
                var a = document.createElement('a');
                a.href = chart.toBase64Image();
                a.download = title + "_" + date + ".png";

                a.click();

                a.remove();
            }

            return false;
        });
    } // if ($('form#StatementSummaryForm').length > 0) {
}); // $(function () {